import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { EventService } from '../core/services/event.service';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { UploadService } from '../core/services/upload.service';
import { environment } from "src/environments/environment";
import { Observable, ReplaySubject } from 'rxjs';


@Component({
  selector: 'app-selfie-redirect',
  templateUrl: './selfie-redirect.component.html',
  styleUrls: ['./selfie-redirect.component.css']
})
export class SelfieRedirectComponent implements OnInit {
  hex: any;
  user: any;
  eventName: any;
  user_name: any;
  mobile: any;
  user_image: any = '';
  //private s3: AWS.S3;
  isFileLoading: boolean = false;
  errorMessage: any;
  base64Output: any;
  event_id: any;
  isOpen: boolean = false;
  isFileSaving: boolean = false;

  constructor(
    private route: ActivatedRoute, private eventService: EventService,
    private router: Router, private afAuth: AngularFireAuth,
    private http: HttpClient, private uploadService: UploadService,
  ) {
   
    this.route.params.subscribe(
      (eventId: any) => {
        // console.log(eventId); //__CONSOLE_LOG__
        this.hex = eventId.id;
      });
  }


  ngOnInit(): void {
    this.isFileLoading = true;
    setTimeout(() => { this.getSelfieData(this.hex); }, 2000);

  }

  openPopup(eventName: string) {
    this.eventName = eventName;
    //this.isFileSaving = false;
    this.isOpen = true;
  }


  closePopup() {
    this.isOpen = false;
    this.router.navigateByUrl('/selfie-message');
  }


  removeSelfie(): void {
    this.user_image = ''; // Clear the image
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;

    if (input.files && input.files[0]) {
      const reader = new FileReader();

      reader.onload = (e: ProgressEvent<FileReader>) => {
        const previewElement = document.getElementById("selfie-preview") as HTMLImageElement;
        if (e.target?.result) {
          previewElement.src = e.target.result as string;
          this.user_image = e.target.result;
        }
      };
      this.convertFile(input.files[0]).subscribe((base64: any) => {
        this.base64Output = base64;
      });
      reader.readAsDataURL(input.files[0]);
    }
  }

  convertFile(file: File): Observable<string> {
    const result = new ReplaySubject<string>(1);
    const reader = new FileReader();
    reader.readAsBinaryString(file);
    reader.onload = (event: any) => result.next(btoa(event.target.result.toString()));
    return result;
  }

  cleanBase64String(base64String: string) {
    const index = base64String.indexOf('/9'); // Find the start of the actual base64 data
    if (index !== -1) {
      return base64String.substring(index); // Extract and return from '/9' onward
    }
    return base64String; // Return the original string if '/9' is not found
  }


  async getSelfieData(hex: any) {
    (await (this.eventService.getSelfieData(hex))).subscribe({
      next: (res: any) => {
        // console.log({ res }); //__CONSOLE_LOG__
        this.isFileLoading = false;
        let resp = res;
        this.event_id = resp.event_data['eventID'];
        this.eventName = resp.event_data['eventName'];
        this.user_name = resp.user_name;
        this.mobile = resp.mobile;
        this.user_image = resp.user_image;
        this.base64Output = this.cleanBase64String(resp.user_image);
      },
      error: (err) => {
        this.isFileLoading = false;
        // console.error(err); //__CONSOLE_LOG__
      },
    });
  }


  skipSelfie() {
    localStorage.setItem('qr-redirect', 'true');
    this.router.navigateByUrl('/event-detail/true');
    // this.afAuth.authState.subscribe((user) => {
    //   if (user) {
    //     // Redirect to event-details if the user is logged in
    //     localStorage.setItem('qr-redirect', 'true');
    //     this.router.navigateByUrl('/event-detail/true');
    //   } else {
    //     // If the user is not logged in, navigate to login
    //     this.router.navigateByUrl('/auth/login');
    //   }
    // });
  }

  async saveSelfie() {
    this.isFileSaving = true;
    (await this.uploadService.uploadMyFace(this.base64Output, this.user_name, this.mobile, this.event_id)).subscribe({
      next: (res: any) => {
        // console.log(res) //__CONSOLE_LOG__
        if (!res.errorMsg) {
          this.isFileLoading = false;
          localStorage.setItem('event_name', this.eventName);
          localStorage.setItem('user_name', this.user_name);
         this.openPopup(this.eventName);// = true;
       //   this.router.navigateByUrl('/selfie-message');
        }
        else {
          this.isFileSaving = false;
          this.errorMessage = res.errorMsg;
        }
      },
      error: (err) => {
        this.errorMessage = null;
        // console.error(err); //__CONSOLE_LOG__
      },
    });
  }
}
